<div class="row justify-content-center mb-5">
  <div class="col-md-6 mb-4 d-flex justify-content-center">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <p-photo-editor
        id="photo1"
        [photo]="getPhotoByIndex(0) ? getPhotoByIndex(0) : ''"
        class="mb-4"
        (croppedImage)="onCroppedPhoto($event, 0)"
        (clearPhoto)="onClearPhoto(0)"
  
      ></p-photo-editor>
      <p-input
        [formControl]="getFormControl('titlePhoto1')"
        id="titlePhoto1"
        placeholder="Photo 1"
        (input)="titleChanged($event, 0)"
      ></p-input>
    </div>
  </div>

  <div class="col-md-6 mb-4 d-flex justify-content-center">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <p-photo-editor
        id="photo2"
        [photo]="getPhotoByIndex(1) ? getPhotoByIndex(1) : ''"
        class="mb-4"
        (croppedImage)="onCroppedPhoto($event, 1)"
        (clearPhoto)="onClearPhoto(1)"

      ></p-photo-editor>
      <p-input
        [formControl]="getFormControl('titlePhoto2')"
        id="titlePhoto2"
        placeholder="Photo 2"
        (input)="titleChanged($event, 1)"
      ></p-input>
    </div>
  </div>

  <div class="col-md-6 mb-4 d-flex justify-content-center">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <p-photo-editor
        id="photo3"
        [photo]="getPhotoByIndex(2) ? getPhotoByIndex(2) : ''"
        class="mb-4"
        (croppedImage)="onCroppedPhoto($event, 2)"
        (clearPhoto)="onClearPhoto(2)"

      ></p-photo-editor>
      <p-input
        [formControl]="getFormControl('titlePhoto3')"
        id="titlePhoto3"
        placeholder="Photo 3"
        (input)="titleChanged($event, 2)"
      ></p-input>
    </div>
  </div>

  <div class="col-md-6 mb-4 d-flex justify-content-center">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <p-photo-editor
        id="photo4"
        [photo]="getPhotoByIndex(3) ? getPhotoByIndex(3) : ''"
        class="mb-4"
        (croppedImage)="onCroppedPhoto($event, 3)"
        (clearPhoto)="onClearPhoto(3)"
        
      ></p-photo-editor>
      <p-input
        [formControl]="getFormControl('titlePhoto4')"
        id="titlePhoto4"
        placeholder="Photo 4"
        (input)="titleChanged($event, 3)"
      ></p-input>
    </div>
  </div>

  <div class="col-md-6 mb-4 d-flex justify-content-center">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <p-photo-editor
        id="photo5"
        [photo]="getPhotoByIndex(4) ? getPhotoByIndex(4) : ''"
        class="mb-4"
        (croppedImage)="onCroppedPhoto($event, 4)"
        (clearPhoto)="onClearPhoto(4)"
        

      ></p-photo-editor>
      <p-input
        [formControl]="getFormControl('titlePhoto5')"
        id="titlePhoto5"
        placeholder="Photo 5"
        (input)="titleChanged($event, 4)"
      ></p-input>
    </div>
  </div>

  <div class="col-md-6 mb-4 d-flex justify-content-center">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <p-photo-editor
        id="photo6"
        [photo]="getPhotoByIndex(5) ? getPhotoByIndex(5) : ''"
        class="mb-4"
        (croppedImage)="onCroppedPhoto($event, 5)"
        (clearPhoto)="onClearPhoto(5)"
        
      ></p-photo-editor>
      <p-input
        [formControl]="getFormControl('titlePhoto6')"
        id="titlePhoto6"
        placeholder="Photo 6"
        (input)="titleChanged($event, 5)"
      ></p-input>
    </div>
  </div>
</div>
